export default function footer() {
  $('.social-logo').hover(
    function() {
      $(this).attr( 'src', $(this).data('hover') );
    },
    function() {
      $(this).attr( 'src', $(this).data('orig') );
    }
  )
}



// WEBPACK FOOTER //
// ./scripts/layout/footer.js